export default __webpack_public_path__ + "static/media/user_img.511c8cf5.svg";